export const createEmptyRole = () => ({
	name: '',
	type: '',
	permissions: [],
});
